/**
 * Код системной роли суперадминистратора.
 * Роль заводится миграцией бэка и не может быть переименована из интерфейса,
 * поэтому проверки прав на неё опираются на код, а не на имя.
 */
export const SUPERADMIN_ROLE_CODE = 'superadmin';
